import { useEffect } from "react";
import $ from "jquery";
import { getState, UpdateState } from "./function";

export const SearchSelect = (props) => {
    let ContainerClass = ".searchable.searchable-"+props.state;
    let ContainerClassX = "searchable searchable-"+props.state;
    if(props.wrapperClass && props.wrapperClass != 'undefined' && props.wrapperClass != ""){
    ContainerClassX += " "+props.wrapperClass;
    }
    let SearchAbleInputClass  = ".searchableInput.searchableInput-"+props.state;
    let SearchAbleInputClassX  = "searchableInput searchableInput-"+props.state;
    let SearchAbleInputX = ".searchable-"+props.state+" input";
    let SearchAbleInputHidden = "searchableInput searchableInput-"+props.state+" readonly";
    let searchAbleULLI = ".searchable.searchable-"+props.state+" ul li";
    useEffect(() => {
    $(function() {
        function filterFunction(that, event) {
          let container, input, filter, li, input_val;
          container = $(that).closest(ContainerClass);
          input_val = container.find("input").val().toUpperCase();

          if (["ArrowDown", "ArrowUp", "Enter"].indexOf(event.key) != -1) {
              keyControl(event, container)
          } else {
              li = container.find("ul li");
              li.each(function (i, obj) {
                  if ($(this).text().toUpperCase().indexOf(input_val) > -1) {
                      $(this).show();
                  } else {
                      $(this).hide();
                  }
              });

              container.find("ul li").removeClass("selected");
              setTimeout(function () {
                  container.find("ul li:visible").first().addClass("selected");
              }, 100)
          }
      }

      $(SearchAbleInputClass).on("keyup", function(e){
        filterFunction(this, e);
      });

      $(SearchAbleInputClass).on("focus", function(e){
      $(this).attr('placeholder', props?.focusplaceholder);
      });

      $(SearchAbleInputClass).on("focusout", function(e){
      $(this).attr('placeholder', props?.placeholder);
      });

      function keyControl(e, container) {
          if (e.key == "ArrowDown") {

              if (container.find("ul li").hasClass("selected")) {
                  if (container.find("ul li:visible").index(container.find("ul li.selected")) + 1 < container.find("ul li:visible").length) {
                      container.find("ul li.selected").removeClass("selected").nextAll().not('[style*="display: none"]').first().addClass("selected");
                  }

              } else {
                  container.find("ul li:first-child").addClass("selected");
              }

          } else if (e.key == "ArrowUp") {

              if (container.find("ul li:visible").index(container.find("ul li.selected")) > 0) {
                  container.find("ul li.selected").removeClass("selected").prevAll().not('[style*="display: none"]').first().addClass("selected");
              }
          } else if (e.key == "Enter") {
              container.find("input").val(container.find("ul li.selected").text()).on();
              //onSelect(container.find("ul li.selected").text())
              onSelect(container.find("ul li.selected").data('value'));
          }

          container.find("ul li.selected")[0].scrollIntoView({
              behavior: "smooth",
          });
      }

          function onSelect(val) {
          if(props.state == 'window_transfer' && props.target != "" && props.target != undefined && props.target != null){
          let Target = props.target?.replace(/@val/g, val);
          window.location.href = Target;
          }
          else{
          UpdateState(props.self, props.state, val);
          }
         //UpdateState(props.self, props.state, val);
         //alert(val);
         //alert(props?.ref?.current?.focus());
         //alert(props.state)
      }

      $(SearchAbleInputX).on('focus', function () {
          $(this).closest(ContainerClass).find("ul").show();
          $(this).closest(ContainerClass).find("ul li").show();
      });
      $(SearchAbleInputX).on('blur', function () {
          let that = this;
          setTimeout(function () {
              $(that).closest(ContainerClass).find("ul").hide();
          }, 300);
      });

      $(document).on('click', searchAbleULLI, function () {
          $(this).closest(ContainerClass).find("input").val($(this).text()).on();
          //onSelect($(this).text())
          onSelect($(this).data('value'));
      });

      $(searchAbleULLI).on('mouseover', function () {
          $(this).closest(ContainerClass).find("ul li.selected").removeClass("selected");
          $(this).addClass("selected");
      });
    });

    $(function() {
    window.setTimeout(function(){
    if(props.defaultValue > 0 ){
    $(searchAbleULLI).each(function(){
    if($(this).data('value') == props.defaultValue){
    $(this).closest(ContainerClass).find("input").val($(this).text()).on();
    let val = $(this).data('value');
    if(props.state == 'window_transfer' && props.target != "" && props.target != undefined && props.target != null){
    let Target = props.target?.replace(/@val/g, val);
    //window.location.href = Target;
    }
    else{
    UpdateState(props.self, props.state, val);
    }
    }
    });
    }
   }, 100);
   });

});

return (<div className={ContainerClassX}>
    <input style={{maxWidth: props.width, borderRadius: props.borderRadius }} ref={(input) => { props.self.SelectInput = input; }} onChange={(input) => UpdateState(props.self, props.state, input.target.value) } type="text" className={props?.data?.length > 0 ? SearchAbleInputClassX : SearchAbleInputHidden} placeholder={props.placeholder} onkeyup="filterFunction(this, event)" readonly={(props.inputReadOnly > 0 || props.inputReadOnly == true || props.inputReadOnly == 'readonly') ? 'true' : false} />
    <ul style={{maxWidth: props.width}} className={(props.inputReadOnly > 0 || props.inputReadOnly == true || props.inputReadOnly == 'readonly') ? 'hidden' : 'sh'}>
    {props?.data?.length > 0 ?
    (props?.data?.map((option, i) => {
      return <li key={i} data-value={option.value}>{option.text}</li>;
     })) : (<div style={{padding: '15px 10px'}}>No Available Data</div>)}
    </ul>
    {/*<div>{getState(props.self, props.state)}</div>*/}
</div>);
}